// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3R1bQ","filesListContainer":"PosDisputesFiles_filesListContainer__3r-LI","filesButton":"PosDisputesFiles_filesButton__2W5qO"};